import React from "react";
import { Box, Skeleton } from "@mui/material";

const LocateCardSkeleton = () => (
  <Box
    sx={{
      width: "400px",
      flexShrink: 0,
      height: "100%",
      maxHeight: "100%",
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "10px",
        flexShrink: 0,
        mb: 1,
      }}
    >
      <Box>
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="text" width={120} height={20} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Skeleton variant="text" width={40} height={16} />
        <Skeleton variant="text" width={40} height={16} />
        <Skeleton variant="circular" width={24} height={24} />
      </Box>
    </Box>

    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr",
          gap: 2,
          p: 1.5,
          borderBottom: "1px solid #e0e0e0",
          flexShrink: 0,
        }}
      >
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="90%" height={20} />
        <Skeleton variant="text" width="90%" height={20} />
        <Skeleton variant="text" width="60%" height={20} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        {Array.from({ length: 12 }).map((_, rowIndex) => (
          <Box
            key={rowIndex}
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr",
              gap: 2,
              p: 1.5,
              borderBottom: rowIndex < 11 ? "1px solid #f0f0f0" : "none",
            }}
          >
            <Skeleton variant="text" width="60%" height={16} />
            <Skeleton variant="text" width="70%" height={16} />
            <Skeleton variant="text" width="70%" height={16} />
            <Skeleton variant="text" width="50%" height={16} />
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

const Step2Skeleton = () => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        minWidth: 0,
        overflow: "hidden",
        gap: 2,
      }}
    >
      <Box sx={{ flexShrink: 0, maxWidth: "600px" }}>
        <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 1 }} />
      </Box>

      <Box
        sx={{
          flex: "1 1 0px",
          minHeight: 0,
          minWidth: 0,
          display: "flex",
          flexWrap: "nowrap",
          overflowX: "auto",
          overflowY: "hidden",
          gap: 2,
          px: 2,
          pb: 1,
          pr: 3,
          alignItems: "stretch",
        }}
      >
        <LocateCardSkeleton />
        <Box sx={{ flexShrink: 0, width: 24 }} />
      </Box>
    </Box>
  );
};

export default Step2Skeleton;
